// Re-Tech services v2 — price list selection, booking form, consent-gated tracking (GA4 + Meta Lead "Service enquiry").
const ANALYTICS_ID = 'G-QR3RPVJ3M1';
const PIXEL_ID = '652282653911679';
const PENDING_KEY = 'retech.sv2.pending.v1';
const LIFETIME = 30 * 60 * 1000;
// Old /pages/услуги?service= ids and ad links → new ids
const LEGACY = {diagnostics: 'diag', thermal: 'care', wordpress: 'web', office: 'm365', marketing: 'web', general: ''};

const root = document.querySelector('[data-sv2]');
if (root && !root.dataset.ready) init(root);

function init(root) {
  root.dataset.ready = '1';
  const live = root.dataset.mode === 'live';
  const freeFrom = Number(root.dataset.freeFrom) || 35;
  const T = root.dataset;
  const form = root.querySelector('#sv2-form');
  const checks = [...root.querySelectorAll('[data-sv2-checks] input[type=checkbox]')];
  const bySid = new Map(checks.map(c => [c.dataset.sid, c]));
  const q = s => root.querySelector(s);
  const fmt = n => `${Math.round(n)} €`;
  const track = makeTracker(root, live);

  // ---------- selection ----------
  function state() {
    const on = checks.filter(c => c.checked);
    let total = 0, quote = false, free = false, hw = false, biz = false;
    for (const c of on) {
      const p = Number(c.dataset.price);
      if (p < 0) quote = true; else total += p;
      if (c.dataset.free === '1') free = true;
      if (c.dataset.group === 'biz') biz = true; else hw = true;
    }
    return {on, total, quote, free: free || total >= freeFrom, hw, biz};
  }

  function render() {
    const st = state();
    for (const [sid, c] of bySid) {
      const item = root.querySelector(`[data-sv2-item="${CSS.escape(sid)}"]`);
      const btn = root.querySelector(`[data-sv2-add="${CSS.escape(sid)}"]`);
      item?.classList.toggle('is-on', c.checked);
      if (btn) {
        btn.setAttribute('aria-pressed', String(c.checked));
        btn.querySelector('span').textContent = c.checked ? T.tAdded : T.tAdd;
      }
    }
    if (!form || !q('[data-sv2-checks]')) return st;
    const totalTxt = st.on.length ? (st.total || !st.quote ? fmt(st.total) : T.tQuote) + (st.quote && st.total ? ' + ' + T.tQuote : '') : '';
    q('[data-sv2-sum-empty]').hidden = st.on.length > 0;
    const pick = q('[data-sv2-pick]');
    let chosen = q('[data-sv2-chosen]');
    if (!chosen) { chosen = document.createElement('ul'); chosen.className = 'sv2-chosen'; chosen.dataset.sv2Chosen = ''; pick.before(chosen); }
    chosen.replaceChildren(...st.on.map(c => { const li = document.createElement('li'); li.textContent = c.closest('label').querySelector('span').textContent + ' · ' + c.closest('label').querySelector('small').textContent; return li; }));
    chosen.hidden = !st.on.length;
    if (!pick.dataset.touched) pick.open = st.on.length === 0;
    q('[data-sv2-sum-lines]').hidden = st.on.length === 0;
    q('[data-sv2-total]').textContent = totalTxt;
    const showShip = st.hw;
    q('[data-sv2-ship-row]').hidden = !showShip;
    const ship = q('[data-sv2-ship]');
    ship.textContent = st.free ? T.tFree : T.tPaid;
    ship.classList.toggle('is-free', st.free);
    const nudge = q('[data-sv2-nudge]');
    const gap = freeFrom - st.total;
    nudge.hidden = !(showShip && !st.free && st.total > 0 && gap > 0);
    if (!nudge.hidden) nudge.textContent = T.tNudge.replace('{x}', Math.ceil(gap));
    q('[data-sv2-total-input]').value = totalTxt;
    q('[data-sv2-ship-input]').value = showShip ? (st.free ? 'Re-Tech' : 'Клиент (под прага)') : '';
    q('[data-sv2-submit-total]').textContent = st.on.length && st.total ? fmt(st.total) : '';
    // fieldsets: hardware unless only business services picked; company only when business picked
    const hwOn = st.hw || !st.biz;
    toggleFs(q('[data-sv2-hw]'), hwOn);
    toggleFs(q('[data-sv2-biz]'), st.biz);
    // dock
    const dock = q('[data-sv2-dock]');
    dock.dataset.has = st.on.length ? '1' : '';
    q('[data-sv2-dock-count]').textContent = st.on.map(c => c.closest('label').querySelector('span').textContent).join(', ').slice(0, 60);
    q('[data-sv2-dock-total]').textContent = totalTxt;
    syncDock();
    return st;
  }

  function toggleFs(fs, on) {
    if (!fs) return;
    fs.hidden = !on;
    fs.querySelectorAll('input,textarea').forEach(el => { el.disabled = !on; });
  }

  root.addEventListener('click', e => {
    const btn = e.target.closest('[data-sv2-add]');
    if (btn) {
      const c = bySid.get(btn.dataset.sv2Add);
      if (!c) return;
      c.checked = !c.checked;
      if (c.checked) track.event('srv_pick', {srv_label: c.dataset.sid});
      render();
      return;
    }
    const t = e.target.closest('[data-sv2-track]');
    if (t) track.event('srv_' + t.dataset.sv2Track, {srv_label: state().on.map(c => c.dataset.sid).join(',')});
  });
  root.querySelector('[data-sv2-pick] summary')?.addEventListener('click', e => { e.currentTarget.parentElement.dataset.touched = '1'; });
  checks.forEach(c => c.addEventListener('change', () => { if (c.checked) track.event('srv_pick', {srv_label: c.dataset.sid}); render(); }));

  // preselect from ?service=a,b (supports old ids)
  const param = new URLSearchParams(location.search).get('service');
  if (param && form) {
    param.split(',').map(s => s.trim()).forEach(id => {
      const sid = id in LEGACY ? LEGACY[id] : id;
      const c = sid && bySid.get(sid);
      if (c) c.checked = true;
    });
  }

  // dock visibility: something picked and booking panel off-screen
  let bookVisible = false;
  const dock = q('[data-sv2-dock]');
  function syncDock() { if (dock) dock.hidden = !(dock.dataset.has && !bookVisible); }
  const book = q('#sv2-book');
  if (book && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => { bookVisible = en.isIntersecting; syncDock(); }, {rootMargin: '0px 0px -20% 0px'}).observe(book);
  }

  render();
  track.event('srv_view', {});

  // ---------- success / error after native post ----------
  const ok = q('[data-sv2-ok]');
  if (ok) {
    ok.focus({preventScroll: true});
    ok.scrollIntoView({block: 'center'});
    track.confirm();
  }
  if (q('[data-sv2-server-error]')) { track.clear(); q('#sv2-book-t')?.scrollIntoView({block: 'start'}); }
  if (!form || ok) return;

  // ---------- validation + submit ----------
  const errBox = q('[data-sv2-formerr]');
  const submitBtn = q('[data-sv2-submit]');
  const lang = root.dataset.locale === 'en' ? 'en' : 'bg';
  const MSG = {
    bg: {req: 'Попълни задължителните полета.', email: 'Провери имейла.', phone: 'Провери телефона.', consent: 'Нужно е съгласие, за да обработим заявката.', offline: 'Няма връзка с интернет. Опитай пак.', stuck: 'Изпращането не беше потвърдено. Опитай пак или ни пиши във Viber.', sending: 'Изпращаме…'},
    en: {req: 'Please fill in the required fields.', email: 'Check the email address.', phone: 'Check the phone number.', consent: 'We need your consent to handle the booking.', offline: 'No internet connection. Try again.', stuck: 'We could not confirm the request. Try again or message us on Viber.', sending: 'Sending…'}
  }[lang];
  const phoneOk = v => (window.ReTechPhone?.isValid ? window.ReTechPhone.isValid(v) : /^\+?[\d\s().-]{7,20}$/.test(v) && (v.match(/\d/g) || []).length >= 7);

  function validate() {
    let first = null, msg = '';
    const fields = [...form.querySelectorAll('input[required],textarea[required]')].filter(el => !el.disabled);
    const bizReq = q('[data-sv2-biz-req]');
    if (bizReq && !bizReq.disabled) fields.push(bizReq);
    for (const el of fields) {
      let bad = false;
      if (el.type === 'checkbox') bad = !el.checked;
      else if (!el.value.trim()) bad = true;
      else if (el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value.trim())) { bad = true; msg = msg || MSG.email; }
      else if (el.type === 'tel' && !phoneOk(el.value.trim())) { bad = true; msg = msg || MSG.phone; }
      if (el.type === 'checkbox') el.closest('label').toggleAttribute('data-invalid', bad);
      else el.setAttribute('aria-invalid', String(bad));
      if (bad && !first) { first = el; if (el.type === 'checkbox') msg = msg || MSG.consent; }
    }
    if (first) { showErr(msg || MSG.req); first.focus(); return false; }
    errBox.hidden = true;
    return true;
  }
  function showErr(text) { errBox.textContent = text; errBox.hidden = false; }
  form.querySelectorAll('input,textarea').forEach(el => el.addEventListener('input', () => {
    if (el.getAttribute('aria-invalid') === 'true') el.setAttribute('aria-invalid', 'false');
    el.closest('label')?.removeAttribute('data-invalid');
  }));

  let busy = false;
  form.noValidate = true;
  form.addEventListener('submit', e => {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy || !validate()) return;
    if (navigator.onLine === false) { showErr(MSG.offline); return; }
    const st = render();
    busy = true;
    submitBtn.disabled = true;
    submitBtn.querySelector('span').dataset.label ||= submitBtn.querySelector('span').textContent;
    submitBtn.querySelector('span').textContent = MSG.sending;
    const services = st.on.map(c => c.dataset.sid);
    track.begin(services, st.total);
    track.event('srv_submit', {srv_label: services.join(',') || 'none', value: st.total, currency: 'EUR'});
    const go = () => { try { form.submit(); } catch { reset(MSG.stuck); } };
    setTimeout(() => { if (busy) reset(MSG.stuck); }, 30000);
    try {
      if (window.Shopify?.captcha?.protect) window.Shopify.captcha.protect(form, go);
      else go();
    } catch { go(); }
  }, {capture: true});
  function reset(text) {
    busy = false; submitBtn.disabled = false;
    const sp = submitBtn.querySelector('span'); sp.textContent = sp.dataset.label || sp.textContent;
    track.clear(); showErr(text);
  }
  window.addEventListener('pageshow', e => { if (e.persisted && busy) reset(MSG.stuck); });
}

// ---------- tracking ----------
function makeTracker(root, live) {
  const queue = [];
  let configured = false;
  const allowed = () => {
    const p = window.Shopify?.customerPrivacy;
    return p?.analyticsProcessingAllowed?.() === true;
  };
  const marketing = () => window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const read = () => { try { return JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null'); } catch { return null; } };
  const write = v => { try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(v)); return true; } catch { return false; } };
  const clear = () => { try { sessionStorage.removeItem(PENDING_KEY); } catch {} };
  const base = {srv_locale: root.dataset.locale || 'bg'};

  function setup() {
    if (configured || !live || !allowed()) return configured;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const s = document.createElement('script');
      s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${ANALYTICS_ID}`;
      document.head.append(s);
      window.gtag('js', new Date());
    }
    window.gtag('config', ANALYTICS_ID, {send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false});
    configured = true;
    return true;
  }
  function flush() {
    if (!setup()) return;
    while (queue.length) { const [n, p] = queue.shift(); window.gtag('event', n, {...base, ...p, send_to: ANALYTICS_ID}); }
    confirm();
  }
  function event(name, params) {
    if (!live) { root.dataset.lastEvent = name; return; }
    queue.push([name, params || {}]);
    flush();
  }

  function meta(attempt) {
    if (!marketing()) return;
    if (!window.fbq) {
      const f = function () { f.callMethod ? f.callMethod.apply(f, arguments) : f.queue.push(arguments); };
      f.queue = []; f.push = f; f.loaded = true; f.version = '2.0';
      window.fbq = f; window._fbq = window._fbq || f;
      if (!document.querySelector('script[src*="fbevents.js"]')) {
        const s = document.createElement('script'); s.async = true; s.src = 'https://connect.facebook.net/en_US/fbevents.js'; document.head.append(s);
      }
    }
    const state = typeof window.fbq.getState === 'function' ? window.fbq.getState() : null;
    if (!state?.pixels?.some(p => String(p.id) === PIXEL_ID) && !window.__rtMetaEnquiryPixelInitialized) {
      window.fbq('init', PIXEL_ID); window.__rtMetaEnquiryPixelInitialized = true;
    }
    // Same event name + content_name as the old services form, so the existing Meta custom conversion keeps counting.
    window.fbq('trackSingle', PIXEL_ID, 'Lead', {content_name: 'Service enquiry', lead_source: 'services_form', service_id: attempt.services.join(',') || 'general', value: attempt.value, currency: 'EUR'}, {eventID: attempt.id});
  }

  function confirm() {
    if (!root.querySelector('[data-sv2-ok]')) return;
    const a = read();
    if (!a || a.sent || a.path !== location.pathname || Date.now() - a.at > LIFETIME) return;
    if (!live) { write({...a, sent: true}); root.dataset.lastEvent = 'service_lead'; return; }
    if (!allowed() || !setup()) return;
    write({...a, sent: true});
    window.gtag('event', 'service_lead', {...base, send_to: ANALYTICS_ID, value: a.value, currency: 'EUR', srv_label: a.services.join(',') || 'none', lead_source: 'services_form', transaction_id: a.id});
    try { meta(a); } catch {}
  }

  const onConsent = () => flush();
  document.addEventListener('visitorConsentCollected', onConsent);
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], err => { if (!err) flush(); });
  }

  return {
    event,
    confirm: () => { if (live) flush(); else confirm(); },
    begin(services, value) {
      const id = window.crypto?.randomUUID?.() || String(Date.now()) + Math.random().toString(16).slice(2);
      write({id: `sv2-${id}`, at: Date.now(), path: location.pathname, services, value: Number(value) || 0, sent: false});
    },
    clear
  };
}
